export default "__VITE_ASSET__Df3zV8vb__"